import React, { FunctionComponent } from 'react';
import { BaseSVGProps } from '../icon.types';

const ChevronLeftIcon: FunctionComponent<BaseSVGProps> = ({
    width,
    height,
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
    >
        <path d="M20.4 24h-7.59L3.6 12l9.21-12h7.59l-9.21 12z" />
    </svg>
);

export default ChevronLeftIcon;
